// extracted by mini-css-extract-plugin
export default {"loader":"LoaderFullContent_loader__o9maP"};